import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck, Loader2 } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/notifications");
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-slate-900">Notifications</h1>
        <Button variant="outline" onClick={markAll} className="rounded-full" data-testid="mark-all-read">
          <CheckCheck className="w-4 h-4 mr-2" /> Mark all read
        </Button>
      </div>

      {loading ? (
        <div className="py-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
      ) : items.length === 0 ? (
        <div className="doccare-card p-10 text-center">
          <Bell className="w-8 h-8 mx-auto text-slate-400" />
          <p className="mt-3 font-semibold text-slate-900">You're all caught up</p>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <button key={n.id} onClick={() => !n.read && markOne(n.id)} className={`w-full text-left doccare-card p-4 flex gap-3 items-start ${n.read ? "opacity-70" : ""}`} data-testid={`notif-${n.id}`}>
              <div className={`w-2 h-2 rounded-full mt-2 ${n.read ? "bg-slate-300" : "bg-emerald-500"}`} />
              <div className="flex-1">
                <p className="font-semibold text-slate-900">{n.title}</p>
                <p className="text-sm text-slate-600">{n.message}</p>
                <p className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
